export default __webpack_public_path__ + "static/media/distractions4.56b2204e.png";